<template>
  <div class="wechatauth-page">授权中...</div>
</template>

<script>
import { Toast } from 'vant';
export default {
  data() {
    return {

    }
  },
  created() {
    Toast.loading({
      message: '授权中...',
      forbidClick: true,
      duration: 0
    });
    if (this.$route.query.token) {
      localStorage.setItem('token', this.$route.query.token);
      let url = window.localStorage.getItem('callback_url')
      if (url) {
        window.location.href = url;
      } else {
        Toast.clear();
        Toast.fail('授权成功，请重新打开页面');
        window.location.href = '/';
      }
    } else {
      Toast.clear();
      Toast.fail('授权失败，请重试');
      setTimeout(() => {
        window.location.href = '/';
      }, 1500);
    }
  }
}
</script>

<style scoped>
.wechatauth-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Wechatauth.vue